import PropTypes from 'prop-types'
import React from 'react'

const RadioButtonButton = React.forwardRef((props, ref) => {
  const { name, checked, value, onChange, disabled, children } = props

  const obtenerClases = () => {
    const arrClases = ['btn btn-publicar-estado-producto']
    if (checked) {
      arrClases.push('clicked')
    }
    if (disabled) {
      arrClases.push('disabled')
    }
    return arrClases.join(' ')
  }

  return (
    <div className="btn-group btn-group-toggle btn-group-vertical">
      <label className={obtenerClases()}>
        <input
          type="radio"
          ref={ref}
          name={name}
          checked={checked}
          value={value}
          onChange={onChange}
          disabled={disabled}
          aria-disabled={disabled}
        />
        {children}
      </label>
    </div>
  )
})

RadioButtonButton.propTypes = {
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  children: PropTypes.node
}

RadioButtonButton.displayName = 'RadioButtonButton'

export default RadioButtonButton
